(function($) {

window.detectTimezone = function(select) {
    Date.prototype.stdTimezoneOffset = function () {
        var jan = new Date(this.getFullYear(), 0, 1);
        var jul = new Date(this.getFullYear(), 6, 1);
        return Math.max(jan.getTimezoneOffset(), jul.getTimezoneOffset());
    }

    /*
    Date.prototype.isDstObserved = function () {
        return this.getTimezoneOffset() < this.stdTimezoneOffset();
    }

    let now = new Date();
    if (now.isDstObserved()) { 
        alert ("Daylight saving time!");
    }
    */

    let timezone_offset_minutes = (new Date()).stdTimezoneOffset();
    timezone_offset_minutes = timezone_offset_minutes == 0 ? 0 : -timezone_offset_minutes;

    return $.get('/helper/detect-timezone', { offset : timezone_offset_minutes }, function(response) {
        if (response.timezone !== '') {
            if (typeof select !== 'undefined') {
                $(select).find('option[value="' + response.timezone + '"]').prop('selected', true);
            }
            return response.timezone;
        }
        return '';
    }, 'json');
};

}(jQuery));
